import React, {useContext} from 'react';
import gql from 'graphql-tag';
import {useQuery} from '@apollo/client';
import {LicenseType, ParentLicense} from '../../../schema';
import Skeleton from '../../../ui/skeleton/Skeleton';
import If from '../../../components/utils/If';
import {AccountContext} from "../../../utils/Context";
import ReactDocumentTitle from "../../../components/ReactDocumentTitle";
import cn from "classnames";
import {createUseStyles} from "react-jss";
import NotFoundScene from "../../system/NotFoundScene";
import SubLicense from "../../../components/license/SubLicense";

interface GetSubLicensesQuery {
  licenses: ParentLicense[];
}

export default function SubLicensesScene() {
  const account = useContext(AccountContext);
  const styles = legacyStyles();

  const {loading, data} = useQuery<GetSubLicensesQuery>(query, {
    errorPolicy: 'all'
  });

  if (!account) {
    return <NotFoundScene/>;
  }

  return (
    <>
      <ReactDocumentTitle title="Trainer licenses"/>
      <div className={cn('flex flex-row justify-between border-b pb-4', styles.borderColor)}>
        <h2 className="text-2xl text-gray-dark font-medium">Licenses</h2>
      </div>
      <div className="py-6">
        <If condition={loading}>
          <Skeleton className="w-4/5 mb-4"/>
          <Skeleton className="w-2/5"/>
        </If>
        {!!data &&
          <>
            <p className="pb-6">
              Company-wide licenses allow you to give licenses to your trainers. If you have a license for 10 trainers,
              you can
              give 10 licenses to your trainers. If a trainer leaves your company, you can revoke their license and
              reassign it
              to a new trainer.
            </p>
            <div className="grid gap-y-4">
              {data.licenses.map(license => (
                <SubLicense license={license} key={license.id} refetchListQuery={['GetSubLicensesQuery', 'licenses']}/>
              ))}
            </div>
          </>
        }
      </div>
    </>
  );
}

const legacyStyles = createUseStyles(
  {
    borderColor: {
      borderColor: '#e7e7e7'
    }
  }
);

const query = gql`
  query GetSubLicensesQuery {
    licenses: parentLicenses {
      id
      typeId
      seats
      expiresAt
      expired
      category {
        id
        name
      }
      type {
        id
        name
      }
      subLicenses {
        id
        licensee {
          id
          name
          avatar
          trainer {
            id
          }
        }
        expired
        expiresAt
        active
      }
    },
  }
`;
